'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect, useCallback } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import useEmblaCarousel from 'embla-carousel-react';
import Calendar from 'assets/icons/calendar.svg';
import Sale from 'assets/icons/sale.svg';
import Lightbox from './Lightbox';
import DateBadge from './DateBadge';
export default function HeroImages(t0) {
  const $ = _c(32);
  const {
    images: t1,
    title: t2,
    locationName: t3,
    showEventsLink: t4,
    showPromotionsLink: t5,
    showTitle: t6,
    badgeStart,
    badgeEnd
  } = t0;
  const images = t1 === undefined ? [] : t1;
  const title = t2 === undefined ? "" : t2;
  const locationName = t3 === undefined ? "" : t3;
  const showEventsLink = t4 === undefined ? true : t4;
  const showPromotionsLink = t5 === undefined ? true : t5;
  const showTitle = t6 === undefined ? true : t6;
  const count = images.length;
  const [activeIndex, setActiveIndex] = useState(null);
  const [isDesktop, setIsDesktop] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      const mq = window.matchMedia("(min-width: 1024px)");
      const update = () => setIsDesktop(mq.matches);
      update();
      mq.addEventListener("change", update);
      return () => mq.removeEventListener("change", update);
    };
    t8 = [];
    $[0] = t7;
    $[1] = t8;
  } else {
    t7 = $[0];
    t8 = $[1];
  }
  useEffect(t7, t8);
  const t9 = count > 1;
  let t10;
  if ($[2] !== t9) {
    t10 = {
      loop: t9,
      skipSnaps: false,
      dragFree: false
    };
    $[2] = t9;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  const [emblaRef, embla] = useEmblaCarousel(t10);
  let t11;
  if ($[4] !== embla) {
    t11 = () => {
      if (!embla) {
        return;
      }
      setSelectedIndex(embla.selectedScrollSnap());
    };
    $[4] = embla;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  const onSelect = t11;
  let t12;
  let t13;
  if ($[6] !== embla || $[7] !== onSelect) {
    t12 = () => {
      if (!embla) {
        return;
      }
      embla.on("select", onSelect);
      embla.on("init", onSelect);
    };
    t13 = [embla, onSelect];
    $[6] = embla;
    $[7] = onSelect;
    $[8] = t12;
    $[9] = t13;
  } else {
    t12 = $[8];
    t13 = $[9];
  }
  useEffect(t12, t13);
  let t14;
  if ($[10] !== setActiveIndex) {
    t14 = index => {
      setActiveIndex(index);
    };
    $[10] = setActiveIndex;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  const openLightbox = t14;
  let t15;
  if ($[12] !== setActiveIndex) {
    t15 = () => setActiveIndex(null);
    $[12] = setActiveIndex;
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  const closeLightbox = t15;
  let t16;
  if ($[14] !== count || $[15] !== setActiveIndex) {
    t16 = () => setActiveIndex(p => (p + 1) % count);
    $[14] = count;
    $[15] = setActiveIndex;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  const goNext = t16;
  let t17;
  if ($[17] !== count || $[18] !== setActiveIndex) {
    t17 = () => setActiveIndex(p_0 => (p_0 - 1 + count) % count);
    $[17] = count;
    $[18] = setActiveIndex;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  const goPrev = t17;
  if (!count) {
    return null;
  }
  let parentClass = "grid gap-4 w-full 2xl:h-[582px] xl:h-[500px] lg:h-[460px] mb-[2em]";
  let getItemClass = _temp;
  if (count === 1) {
    parentClass = "grid grid-cols-1 2xl:h-[582px] xl:h-[500px] lg:h-[460px] mb-[2em]";
    getItemClass = _temp2;
  }
  if (count === 2) {
    parentClass = "grid grid-cols-2 gap-2 2xl:h-[582px] xl:h-[500px] lg:h-[460px] mb-[2em]";
    getItemClass = _temp3;
  }
  if (count >= 3) {
    parentClass = "grid gap-1 xl:grid-cols-[67%_33%] grid-cols-[60%_40%] grid-rows-2 2xl:h-[582px] xl:h-[500px] lg:h-[460px] mb-[2em]";
    getItemClass = _temp4;
  }
  const maxImages = images.slice(0, Math.min(count, 3));
  const showLightbox = activeIndex !== null;
  const t18 = `${isDesktop ? "" : "relative  w-[calc(100%+32px)] -ml-4"}`;
  const t19 = isDesktop ? <div className={parentClass}>{maxImages.map((img, i_1) => <div key={i_1} role="button" tabIndex={0} onClick={() => openLightbox(i_1)} onKeyDown={e => {
      if ((e.key === "Enter" || e.key === " ") && isDesktop) {
        e.preventDefault();
        openLightbox(i_1);
      }
    }} className={`${getItemClass(i_1)} cursor-pointer`}><SafeImage src={img} alt={`Image ${i_1 + 1}`} className="object-cover" />{count > 3 && i_1 === 2 && <div className="absolute inset-0 bg-linear-to-b from-black/10 to-black/50 flex items-center justify-center text-white" onClick={e_0 => {
        e_0.stopPropagation();
        openLightbox(0);
      }}><span className="bg-black/50 rounded-full py-2 px-4 text-sm font-semibold">All Photos</span></div>}</div>)}</div> : <div className="md:h-[500px] h-[382px] w-full max-w-full relative lg:hidden"><div className="md:rounded-b-3xl rounded-b-[20px] inset-0 absolute z-10 pointer-events-none bg-[linear-gradient(180deg,rgba(0,0,0,0)_35.21%,rgba(0,0,0,0)_35.21%,rgba(0,0,0,0.7)_100%)]"><span className="sr-only">overlay</span></div>{showTitle && <div className="absolute left-0 top-auto z-20 bottom-15 pl-5 max-w-[60%] w-full"><h1 className="mb-2 text-white md:text-[2em] text-[1.6em] font-semibold leading-[1.17em] mt-3 overflow-hidden text-ellipsis [display:-webkit-box] [-webkit-line-clamp:2] [-webkit-box-orient:vertical]">{title}</h1><p className="text-white font-outfit md:text-base text-[0.65em] font-medium leading-[1em]">{locationName}</p></div>}{(showEventsLink || showPromotionsLink) && <div className="absolute right-0 top-auto z-20 bottom-7.5 px-5 w-30">{showEventsLink && <Link className="mb-4 block! text-center" href="#communityEvents"><span className="bg-black/40 flex items-center justify-center rounded-full backdrop-blur-sm w-12 h-12 mx-auto"><Image src={Calendar} alt="calendar" /></span><span className="text-white md:text-sm text-xs text-center leading-[1.25em] flex justify-center pt-1.5">{"Events & Attractions"}</span></Link>}{showPromotionsLink && <Link className="text-white md:text-sm text-xs text-center leading-[1.25em] block!" href="#communityPromotions"><span className="bg-black/40 flex items-center justify-center rounded-full backdrop-blur-sm w-12 h-12 mx-auto"><Image src={Sale} alt="sale" /></span><span className="text-white md:text-sm text-xs text-center leading-[1.25em] flex justify-center pt-1.5">Promotions</span></Link>}</div>}{(badgeStart || badgeEnd) && <div className="absolute right-0 top-auto z-20 bottom-15 px-5"><DateBadge badgeStart={badgeStart} badgeEnd={badgeEnd} /></div>}<div className="overflow-hidden md:rounded-b-3xl rounded-b-[20px]" ref={emblaRef}><div className="flex">{images.map((img_0, i_2) => <button key={i_2} type="button" onClick={() => openLightbox(i_2)} className="relative flex-[0_0_100%] w-full md:h-[500px] h-[382px] cursor-pointer"><SafeImage src={img_0} alt={`Image ${i_2 + 1}`} className="object-cover" /></button>)}</div></div>{count > 1 && <div className="absolute bottom-6 left-0 right-0 flex justify-center gap-2 z-30">{(() => {
        let start = 0;
        let end = count;
        if (count > 5) {
          if (selectedIndex <= 2) {
            start = 0;
            end = 5;
          } else {
            if (selectedIndex >= count - 3) {
              start = count - 5;
              end = count;
            } else {
              start = selectedIndex - 2;
              end = selectedIndex + 3;
            }
          }
        }
        return images.slice(start, end).map((_, i_3) => {
          const realIndex = start + i_3;
          return <div key={realIndex} onClick={() => embla && embla.scrollTo(realIndex)} className={`w-1.5 h-1.5 rounded-full transition-all cursor-pointer ${selectedIndex === realIndex ? "bg-white w-4!" : "bg-white/60 hover:bg-white/80"}`} />;
        });
      })()}</div>}</div>;
  let t20;
  if ($[20] !== activeIndex || $[21] !== closeLightbox || $[22] !== goNext || $[23] !== goPrev || $[24] !== images || $[25] !== setActiveIndex || $[26] !== showLightbox) {
    t20 = showLightbox && <Lightbox images={images} activeIndex={activeIndex} close={closeLightbox} goNext={goNext} goPrev={goPrev} goTo={setActiveIndex} key={activeIndex} />;
    $[20] = activeIndex;
    $[21] = closeLightbox;
    $[22] = goNext;
    $[23] = goPrev;
    $[24] = images;
    $[25] = setActiveIndex;
    $[26] = showLightbox;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] !== t18 || $[29] !== t19 || $[30] !== t20) {
    t21 = <div className={t18}>{t19}{t20}</div>;
    $[28] = t18;
    $[29] = t19;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  return t21;
}
function _temp4(i_0) {
  if (i_0 === 0) {
    return "relative col-span-1 row-span-2 w-full h-full overflow-hidden rounded-l-xl";
  }
  if (i_0 === 1) {
    return "relative w-full h-full overflow-hidden rounded-tr-xl";
  }
  if (i_0 === 2) {
    return "relative w-full h-full overflow-hidden rounded-br-xl";
  }
  return "hidden";
}
function _temp3(i) {
  return i === 0 ? "relative w-full h-full overflow-hidden rounded-l-xl" : "relative w-full h-full overflow-hidden rounded-r-xl";
}
function _temp2() {
  return "relative w-full h-full overflow-hidden rounded-xl";
}
function _temp() {
  return "relative w-full h-full overflow-hidden rounded-xl";
}
function SafeImage(t0) {
  const $ = _c(5);
  const {
    src,
    alt,
    className
  } = t0;
  if (!src) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="w-full h-full bg-gray-200 flex items-center justify-center" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== alt || $[2] !== className || $[3] !== src) {
    t1 = <Image src={src} alt={alt} fill={true} className={className} />;
    $[1] = alt;
    $[2] = className;
    $[3] = src;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}